import React from 'react'

import withTwitterWidgets from '../../withTwitterWidgets'

const ProfileSectionTwitter = withTwitterWidgets(({ section, Timeline }) => {
  if (section.screenName) {
    return (
      <Timeline
        dataSource={{
          sourceType: 'profile',
          screenName: section.screenName
        }}
        options={{
          username: section.screenName,
          height: '500',
          chrome: 'noheader,nofooter'
        }}
        onLoad={() => console.log('Timeline is loaded!')}
      />
    )
  }

  return null
})

export default ProfileSectionTwitter
